import { getAuth, createUserWithEmailAndPassword, 
    signInWithEmailAndPassword, onAuthStateChanged,
    signOut
} from "firebase/auth";
import { getFirestore, collection, 
  doc, setDoc,
  query, where,getDocs
} from "firebase/firestore";
import{app} from "../firebase/data"


import {toast} from "react-hot-toast";


// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);
// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);
const usersRef = collection(db, "users");



//!UPDATE USER DATA
export async function updateUserData2(creator,name, lastName, email,DNI, phone,address,course,legajo, year, success){
  try {
    const docRef = await setDoc(doc(usersRef, creator), {
      creator,
      name,
      lastName,
      email,
      DNI, 
      phone,
      address,
      course,
      legajo, 
      year, 
      success,
      status:true
    },{merge:true}
  )
    toast.success("Tus datos fueron actualizados")

  } catch (error) {
    toast.error("Error actualizando los datos: "+ error.code);
    toast.error(error.message);
  }

}


//!READ USER DATA
// Create a query against the collection.
export async function findUserData(creatorName){

  let userDataArray=[]

  const q = query(usersRef, where("creator", "==", creatorName));
  const querySnapshot = await getDocs(q);
  const userDATA= querySnapshot.forEach((doc) => {
    // doc.data() is never undefined for query doc snapshots
    console.log(doc.id, " => ", doc.data());
    userDataArray.push(doc.data())
    //console.log(userDataArray)
  });

  return userDataArray;
}


//!REGISTER
export async function registerUser(email, password){

  let word=[]

    //convertí en await para que espere el resultado y use un array
    const register = await   createUserWithEmailAndPassword(auth, email, password)
    .then((userCredential) => {
      // Signed in 
      const user = userCredential.user;
      toast.success(`Bienvenido ${user.email}`)

    })
    .catch((error) => {
      const errorMessage = error.message;
      word.push(1)

      toast.error(errorMessage)
      if(errorCode==="auth/email-already-in-use"){
        toast.error("Correo ya registrado")
      }
      if(errorCode==="auth/invalid-email"){
        toast.error("Correo inválido")
      }
    });

    return word
}


//!LOGIN
export async function loginUser (email, password){
  signInWithEmailAndPassword(auth, email, password)
  .then((userCredential) => {
    // Signed in 
    const user = userCredential.user;
    toast.success(`Bienvenido ${user.email}`)
  })
  .catch((error) => {
    const errorCode = error.code;
    const errorMessage = error.message;

    toast.error(errorMessage)

    if(errorCode==="auth/invalid-email"){
        toast.error("Correo inválido")
    }
    if(errorCode==="auth/wrong-password"){
      toast.error("Contraseña inválida")
    }
  });
}

//!LOGOUT
export async function logout (){
    signOut(auth).then(() => {
        // Sign-out successful.
        toast.success('Hasta pronto')

      }).catch((error) => {
        toast.error(`Error: ${error.code}`)
        toast.error(error.message)


    });
}



//!AUTH STATE